import Immutable from 'immutable'
import { types } from 'store/actions/user'

const initialState = new Immutable.Map({
  pending: false,
  dateLoaded: undefined,
  errors: new Immutable.List(),
  isSignedIn: undefined,
  profile: new Immutable.OrderedMap(),
  learningStats: new Immutable.OrderedMap(),
})

export default function userReducer(state = initialState, action) {
  const { type, payload } = action
  let ret = state
  switch(type) {
    /***
     * PENDING
     */
    case `${types.GET_PROFILE}_PENDING`: {
      ret = ret.set('pending', true)
        .update('errors', errors => errors.clear())
      break
    }

    /***
     * REJECTED
     */
    case `${types.GET_PROFILE}_REJECTED`: {
      try {
        if(payload.response.status === 403) {
          window.location = '/learning/pages/auth.aspx'
        }
      } catch(_err) {
        //pass
      }
      ret = ret.set('pending', false)
        .set('dateLoaded', undefined)
        .update('errors', errors => errors.unshift(new Immutable.Map({
          message: payload.message,
          date: new Date(),
        })))
      break
    }

    /***
     * FULFILLED
     */
    case `${types.GET_PROFILE}_FULFILLED`: {
      ret = ret.set('pending', false)
        .set('dateLoaded', new Date())
        .update('errors', errors => errors.clear())

      if(payload && payload.profile) {
        ret = ret.set('profile', Immutable.fromJS(payload.profile))
          .set('learningStats', Immutable.fromJS(payload.learningStats))
      }

      break
    }
    // no default
  }

  ret = ret.set('isSignedIn', (ret.has('dateLoaded') && ret.has('profile') && !ret.get('profile').isEmpty()))

  return ret
}
